<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
    <div class="magnification-selector">
        <div class="buttons has-addons are-small">
            <button class="button" @click="$emit('fit')">
                Fit
            </button>
            <button v-for="mag in magnifications" :key="mag" class="button"
                :class="{ 'is-selected': isCurrentMagnification(mag) }" @click="$emit('setMagnification', mag)">
                {{ mag }}X
            </button>
        </div>
    </div>
</template>

<script>
import { getAvailableMagnifications, getMagnificationForZoom } from './magnifications';

export default {
    name: 'magnification-selector',
    props: {
        image: Object,
        zoom: Number
    },
    computed: {
        magnifications() {
            return getAvailableMagnifications(this.image);
        },
        currentMagnification() {
            return getMagnificationForZoom(this.image, this.zoom);
        }
    },
    methods: {
        isCurrentMagnification(mag) {
            if (!this.currentMagnification) return false;
            return Math.abs(this.currentMagnification - mag) < 0.1;
        }
    }
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/dark-variables';
@import '../../assets/styles/viewer-layers';

.magnification-selector {
    position: absolute;
    left: 0.5rem;
    top: 3.25rem;
    z-index: $viewer-z-image-controls;
    pointer-events: auto;
    background: rgba(17, 28, 42, 0.92);
    border: 1px solid rgba(145, 171, 196, 0.26);
    border-radius: 8px;
    padding: 0.18rem;
    box-shadow: 0 12px 26px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(12px);
}

.buttons {
    display: flex;
    align-items: center;
    gap: 0.16rem;
    margin: 0 !important;
}

.button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    box-sizing: border-box;
    min-width: 2.65rem;
    height: 1.8rem;
    padding: 0 0.52rem !important;
    background-color: transparent !important;
    color: rgba($dark-text-secondary, 0.88) !important;
    border: 1px solid transparent !important;
    border-radius: 6px !important;
    font-size: 0.78rem !important;
    font-weight: 650;
    line-height: 1 !important;
    margin: 0 !important;
    box-shadow: none !important;
    text-align: center;
    white-space: nowrap;
    letter-spacing: 0;

    &:hover {
        background-color: rgba($primary, 0.1) !important;
        color: $primary !important;
    }

    &.is-selected {
        background-color: rgba($primary, 0.14) !important;
        color: $primary !important;
        border-color: rgba($primary, 0.64) !important;
        box-shadow: inset 0 0 0 1px rgba($primary, 0.18) !important;
    }
}

.buttons.has-addons .button:not(:last-child),
.buttons.has-addons .button:not(:first-child) {
    border-radius: 6px !important;
    margin-left: 0 !important;
}
</style>
